import { z } from "zod";
const MIN_RESOLVE_TOKEN_EXPIRY_HOURS = 1;
const MAX_RESOLVE_TOKEN_EXPIRY_HOURS = 168;
const DEFAULT_RESOLVE_TOKEN_EXPIRY_HOURS = 24;
const resolveTokenExpiryHoursSchema = z.number({
    invalid_type_error: 'Duration must be a number'
}).int('Duration must be a whole number').min(MIN_RESOLVE_TOKEN_EXPIRY_HOURS, `Duration must be at least ${MIN_RESOLVE_TOKEN_EXPIRY_HOURS} hour`).max(MAX_RESOLVE_TOKEN_EXPIRY_HOURS, `Duration must be at most ${MAX_RESOLVE_TOKEN_EXPIRY_HOURS} hours`);
export { DEFAULT_RESOLVE_TOKEN_EXPIRY_HOURS, MAX_RESOLVE_TOKEN_EXPIRY_HOURS, MIN_RESOLVE_TOKEN_EXPIRY_HOURS, resolveTokenExpiryHoursSchema };
